<template>
    <div class="resultsWrapper flexContainer fw-w full" id="planoList">
        <!-- TODO: refactor events to not take "item" as parameter -->
        <PlanoListItem
            v-for="item in listPlano"
            :key="item.id"
            :item="item"
            :dense="type !== 'catalog'"
            @openEditNameModal="showEditNameModal"
            @showDuplicateModal="showDuplicateModal"
            @changeStatusPlano="changeStatusPlano"
            @openPlano="openPlano"
            @modalComment="modalComment"
            @archivedPlano="archivedPlano"
            @version="version"
        ></PlanoListItem>
        <duplicate
            v-if="showModal"
            :show="showModal"
            :currentPlanoCampaign="currentPlanoCampaign"
            :currentPlanoZone="currentPlanoZone"
            :currentPlanoId="currentPlanoId"
            :currentPlanoName="currentPlanoName"
            :currentStandDesign="currentStandDesign"
            @close="showModal = false;"
        ></duplicate>
        <editName
            :show="showModalEditName"
            :currentPlanoId="currentPlanoId"
            :currentPlanoName="currentPlanoName"
            @close="showModalEditName = false;"
        ></editName>
        <Comment v-if="showModalComment" @closeModal="modalClose($event);"></Comment>
        <Modal :action="dataAction"></Modal>
        <modalPlanoVersion v-if="versionList" @hideEditPlanoVersion="modalClose($event);"></modalPlanoVersion>
    </div>
</template>

<script>
import PlanoListItem from "./plano-list-item.vue";
import httpService from "../service";
import Duplicate from "../planos/duplicate.vue";
import editName from "../planos/editName.vue";
import Comment from "../modal/modalComment.vue";
import Modal from "../planos/modal/Modal";
import Spinner from "vue-simple-spinner";
import modalPlanoVersion from "../planos/modalPlanoVersion";
import { mapActions } from "vuex";
import cacheService from "@/services/cache";

const SystemType = {
    TILE: 1,
    SHELF: 2,
    CADDY: 3
};

export default {
    name: "planoList",
    props: ["listPlano", "type"],
    components: {
        PlanoListItem,
        Duplicate,
        editName,
        Comment,
        Spinner,
        Modal,
        modalPlanoVersion
    },
    data() {
        return {
            dataAction: "",
            rem3rchUser: {},
            selectedCampaign: cacheService.getCurrentCampaignId(),
            selectedZone: cacheService.getCurrentZoneId(),
            selectedBrand: cacheService.getCurrentBrandId(),
            clientColor: cacheService.getLinkColor(),
            showModal: false,
            showModalEditName: false,
            planoToDuplicate: null,
            currentPlanoCampaign: null,
            currentPlanoZone: null,
            currentPlanoId: null,
            currentPlanoName: null,
            currentStandDesign: null,
            action: null,
            idPlano: "",
            showModalComment: false,
            loading: false,
            editIndex: null,
            editInput: false,
            editPlanoName: {},
            versionList: false,
            showOption: false
        };
    },
    created() {
        this.rem3rchUser = cacheService.getRem3rchUser();
    },
    mounted() {},
    methods: {
        ...mapActions({
            setPlanoVersion: "planos/search/setPlanoVersion",
            setPlanoName: "planos/search/setPlanoName"
        }),
        savePlanoNewName() {
            let saveNamePlano = {
                name: this.editPlanoName.name
            };
            this.editInput = false;
            httpService.post("/plano/" + this.editPlanoName.id, JSON.stringify(saveNamePlano)).then(response => {});
        },
        modalClose(close) {
            this.showModalComment = close;
            this.versionList = close;
        },
        modalComment(plano) {
            this.showModalComment = !this.showModalComment;
            cacheService.set("plano", plano);
        },
        openPlano(plano) {
            this.loading = true;
            cacheService.set("planoLocked", plano.isLocked);

            const systemTypeId = plano && plano.template && plano.template.systemType && plano.template.systemType.id;
            const isNext = systemTypeId === SystemType.SHELF || systemTypeId === SystemType.CADDY;

            if (isNext) {
                const brandId = cacheService.getCurrentBrandId();
                const zoneId = cacheService.getCurrentZoneId();
                this.$router.push(`/planonext/${plano.id}`);
            } else {
                this.$router.push(`/plano/${plano.id}`);
            }
            this.selectedCampaign = plano.campaign.id;
            cacheService.set("currentCampaignId", plano.campaign.id);
        },
        changeStatusPlano(idPlano, value, action) {
            this.dataAction = {
                errorMsg: false,
                action: action,
                id: idPlano,
                value: value
            };
            this.$root.$emit("bv::show::modal", "defaultModalStatus");
        },
        archivedPlano(item, action) {
            this.dataAction = {
                errorMsg: false,
                action: action,
                id: item.id,
                status: item.status,
                archived: item.archived
            };
            this.$root.$emit("bv::show::modal", "defaultModalStatus");
        },
        showDuplicateModal(plano) {
            this.showModal = true;
            this.currentPlanoCampaign = plano.campaign.id;
            this.currentPlanoZone = plano.zone.id;
            this.currentPlanoId = plano.id;
            this.currentPlanoName = plano.name;
            this.currentStandDesign = plano.standDesign.id;
        },
        showEditNameModal(plano, $event) {
            this.showModalEditName = true;
            this.action = $event;
            this.currentPlanoId = plano.id;
            this.currentPlanoName = plano.name;
        },
        version(id, name) {
            httpService.get("/plano/" + id + "/versioned").then(response => {
                this.versionList = true;
                this.setPlanoVersion(response);
                this.setPlanoName(name);
            });
        }
    }
};
</script>

<style scoped lang="scss">
#planoList {
    margin-top: 10px;
    .statusBar {
        background-color: white;
        ul {
            background-color: #ffffff;
            padding: 0px;
            margin: 0;
            li {
                list-style: none;
                margin: 0;
                text-transform: uppercase;
                &.active {
                    color: #343434;
                    transition: 0.2s;
                    background-color: #f4f4f4;
                }
                &#titleFilters {
                    font-size: 18px;
                    font-family: Roboto;
                    color: #343434;
                    padding: 20px 30px;
                    .clear {
                        text-decoration: none;
                        color: #343434;
                        top: -5px;
                        &:hover {
                            color: #343434;
                        }
                    }
                }
                &.filtersBtn {
                    font-size: 1.4rem;
                    color: #999;
                    padding: 20px;
                    border-bottom: 1px solid #c6c6c6;
                    width: 90%;
                    margin-left: 5%;
                    &:hover {
                        color: #343434;
                        transition: 0.2s;
                        background-color: #f4f4f4;
                    }
                }
            }
        }
    }
    .searchResultsWrapper {
        margin: 0 10px;
        background-color: white;
        border-radius: 3px;
        padding: 30px;
        #planoFilters {
            font-size: 14px;
            .filter {
                font-size: 14px;
                padding: 0 15px;
                font-weight: 500;
                &:first-child {
                    padding-left: 0;
                }
                &:last-child {
                    padding-right: 0;
                }
                &.abs {
                    right: 0;
                }
                select {
                    border: none;
                    background: none;
                    font-weight: 300;
                    bottom: 2px;
                    margin-left: 5px;
                }
            }
        }
        .resultsWrapper {
            padding-top: 30px;
            .item {
                font-size: 1.4rem;
                background: #f4f4f4;
                margin-bottom: 20px;
                .contextMenu {
                    background-color: darkgrey;
                    width: 92px;
                }
                .status {
                    padding: 5px;
                    min-width: 85px;
                }
            }
        }
        #searchInputPlanos {
            height: 30px;
            border-left: none;
            border-top: none;
            border-right: none;
            font-size: 14px;
        }
        .separator {
            border-top: none;
            border-left: none;
            border-right: none;
        }
    }
}

.pagination {
    .pageLink {
        font-size: 1.6rem;
        width: 20px;
        height: 20px;
        margin: 0 2px;
        text-align: center;
        text-decoration: none;
        color: #343434;
        &:hover {
            color: #343434;
        }
        &.active {
            color: rgb(200, 0, 0);
            font-weight: 700;
        }
    }
}

#optionsList {
    background-color: #f4f4f4;
    padding: 0.65rem 1.7rem;
}

@media only screen and (max-width: 767px) {
    .planoListMob {
        margin-top: 30px;
        .separator {
            border-top: none;
            border-left: none;
            border-right: none;
            border-color: #ccc;
        }
    }
    .planoMob {
        background-color: white;
        width: inherit;
        margin-bottom: 25px;
        padding: 10px;
    }
    #planoFilters {
        .filter {
            &:last-child {
                div {
                    width: 17%;
                }
            }
        }
        select {
            width: 100%;
            position: relative;
            bottom: 3px;
        }
    }
    .title {
        margin: 0px 15px 30px 15px;
        figure {
            height: 200px;
            max-width: 100%;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }
        h3 {
            font-size: 1.4rem;
        }
    }
    .imgPlano {
        margin-top: 18px;
    }
    .titleCampaign {
        margin-top: 4px;
    }
    .infos {
        padding-bottom: 15px;
        p {
            font-size: 1.4rem;
        }
    }
    .headerStatus {
        height: 30px;
        .statusPlano {
            margin-top: auto;
            margin-bottom: auto;
        }
        .locked {
            margin-right: 5px;
        }
    }
    .planoName {
        font-size: 17px;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    #planoList {
        .statusBar {
            width: 100%;
            padding: 0 15px;
            ul {
                li {
                    &#titleFilters {
                        font-size: 1.4rem;
                        padding-left: 0;
                        padding-right: 0;
                        text-align: center;
                        display: block;
                        .clear {
                            top: initial;
                            right: initial;
                            width: 100px;
                            margin: auto;
                            margin-top: 15px;
                            font-size: 1.1rem;
                            float: none;
                        }
                    }
                    &.filtersBtn {
                        font-size: 1.2rem;
                        text-align: center;
                        padding: 15px 0;
                        span {
                            float: none;
                        }
                    }
                }
            }
        }
        #planoFilters {
            font-size: 1.1rem;
        }
        .planoListMob {
            width: 100%;
            margin-left: 20px;
            select {
                position: relative;
                bottom: 3px;
            }
            .separator {
                border-top: none;
                border-left: none;
                border-right: none;
                border-color: #ddd;
                &:last-child {
                    margin-bottom: 20px;
                }
            }
            .planoMob {
                background-color: #fff;
                width: inherit;
                margin-bottom: 25px;
                padding: 10px;
                font-size: 1.4rem;
                .headerStatus {
                    height: 30px;
                    .statusPlano {
                        margin-top: auto;
                        margin-bottom: auto;
                    }
                    .locked {
                        margin-right: 5px;
                    }
                }
                .planoName {
                    font-size: 1.8rem;
                    margin-top: 0;
                }
                h2 {
                    margin-bottom: 0;
                }
            }
            .title {
                margin-bottom: 15px;
            }
            .infos {
                padding: 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// planoList.vue?ea271d40